import { render } from "./your-channel-programs.vue?vue&type=template&id=4854d6c4&lang=pug"
import script from "./your-channel-programs.vue?vue&type=script&lang=js"
export * from "./your-channel-programs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__